<div class="phone-list-wrapper">
    <app-phone-item
        *ngFor="let phone of phones$ | async"
        [phone]="phone"
        (selected)="selectPhone(phone)"
        class="phone-item"
    ></app-phone-item>
</div>